export default __webpack_public_path__ + "static/toptal-120b7407d1636db0c83fb16f8c21ad4a.png";